import { FaExternalLinkAlt } from "react-icons/fa";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Skeleton } from "../../ui/skeleton";
import {
  formatDateTime,
  formatPercent,
  formatUsd,
} from "../formatters";

const LoadingTable = () => (
  <div className="reddicks-top-table-shell">
    <table className="reddicks-top-table">
      <thead>
        <tr>
          <th>Pair</th>
          <th>TVL</th>
          <th>Latest Volume</th>
          <th>Latest Fees</th>
          <th>Spread</th>
          <th>Last Update</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 5 }).map((_, rowIndex) => (
          <tr key={`top-pairs-loading-${rowIndex}`}>
            {Array.from({ length: 6 }).map((__, cellIndex) => (
              <td key={`top-pairs-loading-${rowIndex}-${cellIndex}`}>
                <Skeleton className="h-4 w-full max-w-[8rem]" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ReddicksTopPairsTable = ({ topPairs, isLoading, hasCachedData }) => {
  const shouldShowLoading = isLoading && !hasCachedData;
  const rows = Array.isArray(topPairs) ? topPairs : [];

  return (
    <Card className="leaderboard-surface-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Top 5 Official REDDICKS Markets</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="leaderboard-data-hint leaderboard-data-hint-market">
          Ranked by TVL with latest per-pair volume, fees, spread, and freshness.
        </p>
        {shouldShowLoading ? (
          <LoadingTable />
        ) : rows.length === 0 ? (
          <div className="reddicks-chart-empty">
            No official REDDICKS market rows are available right now.
          </div>
        ) : (
          <div className="reddicks-top-table-shell">
            <table className="reddicks-top-table">
              <thead>
                <tr>
                  <th>Pair</th>
                  <th>TVL</th>
                  <th>Latest Volume</th>
                  <th>Latest Fees</th>
                  <th>Spread</th>
                  <th>Last Update</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.pairAddress}>
                    <td>
                      <a
                        href={`https://www.radxplorer.com/components/${row.pairAddress}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="reddicks-top-table-link"
                      >
                        {row.pairLabel}
                        <FaExternalLinkAlt className="h-3 w-3" />
                      </a>
                    </td>
                    <td>{formatUsd(row.tvlUsd)}</td>
                    <td>{formatUsd(row.latestVolumeUsd)}</td>
                    <td>{formatUsd(row.latestFeesUsd)}</td>
                    <td>{formatPercent(row.spreadPct, "N/A")}</td>
                    <td>{formatDateTime(row.updatedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ReddicksTopPairsTable;
